import { useLocation, useNavigate } from "react-router-dom";
import { DefaultAddNewHeader } from "..";
import { memo, useCallback } from "react";

interface DefaultAddNewEntityProps {
  entityName: string;
  addNewMutation: Function;
  editor: (saveCallback: (data: any, getError?: (error: any) => void) => Promise<boolean>) => JSX.Element;
  navigateToEditAfterSave?: boolean;
}

const DefaultAddNewEntity = memo(({ entityName, addNewMutation, editor, navigateToEditAfterSave = false }: DefaultAddNewEntityProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [addNewEntity] = addNewMutation();

  const save = useCallback(
    async (model: any, getError?: (error: any) => void) => {
      try {
        const saved = await addNewEntity(model).unwrap();
        const savedId = Number(saved?.id);

        if (navigateToEditAfterSave && Number.isFinite(savedId) && savedId > 0) {
          navigate(location.pathname.replace("/new", `/${savedId}/edit`), {
            replace: true,
            state: location.state,
          });
        } else {
          navigate(location.pathname.replace("/new", ""), { state: location.state });
        }
        return true;
      } catch (error) {
        if (getError) {
          getError(error);
        }
        return false;
      }
    },
    [addNewEntity, location, navigate, navigateToEditAfterSave]
  );

  return (
    <div>
      <DefaultAddNewHeader entityName={entityName} />

      {editor(save)}
    </div>
  );
});

export const GetDefaultAddNewEntity =
  ({ entityName, addNewMutation, editor, navigateToEditAfterSave }: DefaultAddNewEntityProps) =>
  () =>
    <DefaultAddNewEntity
      entityName={entityName}
      addNewMutation={addNewMutation}
      editor={editor}
      navigateToEditAfterSave={navigateToEditAfterSave}
    />;
